import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import App from './App';
import { ErrorBoundary } from './components/ErrorBoundary';
import { trackDailyVisit } from './lib/track';
import { initErrorMonitoring } from './lib/sentry';
import { registerServiceWorker } from './lib/pwa';
import './index.css';

initErrorMonitoring(); // 오류 모니터링 — DSN이 있을 때만 동작 (개인정보 미전송)
trackDailyVisit(); // 하루 1회 방문 집계 (개인정보 無)
registerServiceWorker(); // 재방문 속도·오프라인 셸 (웹 빌드에서만)

const queryClient = new QueryClient({
  defaultOptions: { queries: { staleTime: 30_000, retry: 1 } },
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </QueryClientProvider>
    </ErrorBoundary>
  </React.StrictMode>,
);
